import * as React from 'react';
import { cn } from '../../lib/utils.js';

export const Label = React.forwardRef<
  HTMLLabelElement,
  React.LabelHTMLAttributes<HTMLLabelElement>
>(({ className, ...props }, ref) => (
  <label
    ref={ref}
    className={cn(
      'font-mono text-[10px] font-semibold uppercase tracking-[0.14em] text-muted-foreground',
      className,
    )}
    {...props}
  />
));
Label.displayName = 'Label';
